import { createFileRoute } from "@tanstack/react-router";
import { useState, ChangeEvent } from "react";
import useTranslation from "../hooks/useTranslation";

export const Route = createFileRoute("/start-learning")({
  component: RouteComponent,
});

function RouteComponent() {
  return <SingleUserSignup />;
}

function SingleUserSignup() {
  const [step, setStep] = useState(1);
  const [plan, setPlan] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleNext = () => {
    if (step === 1 && plan) setStep(2);
    else if (step === 2 && formData.name && formData.email && formData.password)
      setStep(3);
  };

  const { translate } = useTranslation();

  return (
    <div className="max-w-xl mx-auto p-6 space-y-6">
      {step === 1 && (
        <>
          <h1 className="text-3xl font-bold text-center">
            {translate("form_header_choose_plan")}
          </h1>
          <p className="text-center text-gray-600">
            {translate("form_subtext_choose_plan")}
          </p>

          <form className="space-y-4 mt-6">
            {["free", "standard", "pro"].map((p) => (
              <label
                key={p}
                className="flex items-start gap-4 p-4 border rounded-xl cursor-pointer"
              >
                <input
                  type="radio"
                  name="plan"
                  value={p}
                  checked={plan === p}
                  onChange={() => setPlan(p)}
                  className="mt-1"
                />
                <div>
                  <div className="font-semibold text-lg capitalize">
                    {translate(`plan_${p}_title`)}
                  </div>
                  <div className="text-sm text-gray-500">
                    {translate(`plan_${p}_desc`)}
                  </div>
                </div>
              </label>
            ))}
          </form>

          <div className="text-center pt-4">
            <button
              onClick={handleNext}
              disabled={!plan}
              className="w-full px-4 py-2 rounded-sm bg-blue-600 text-white disabled:bg-gray-300"
            >
              {translate("btn_continue")}
            </button>
          </div>
        </>
      )}

      {step === 2 && (
        <>
          <h2 className="text-2xl font-bold text-center">
            {translate("form_header_register")}
          </h2>
          <div className="space-y-4 mt-6">
            <input
              type="text"
              name="name"
              placeholder={translate("input_name")}
              value={formData.name}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-sm"
            />
            <input
              type="email"
              name="email"
              placeholder={translate("input_email")}
              value={formData.email}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-sm"
            />
            <input
              type="password"
              name="password"
              placeholder={translate("input_password")}
              value={formData.password}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-sm"
            />
            <button
              onClick={handleNext}
              className="w-full px-4 py-2 rounded-sm bg-blue-600 text-white"
            >
              {translate("btn_continue_to_payment")}
            </button>
          </div>
        </>
      )}

      {step === 3 && (
        <>
          <h2 className="text-2xl font-bold text-center">
            {translate("form_header_payment")}
          </h2>
          <p className="text-center text-gray-500">
            {translate("form_subtext_payment_placeholder")}
          </p>
          <div className="text-center mt-6">
            <button
              onClick={() => alert("Signed up!")}
              className="px-6 py-2 bg-green-600 text-white rounded-sm"
            >
              {translate("btn_complete_signup")}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
